import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthStatus, ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { siPayInitialize } from './30pay.scripts';
import './30pay.style.scss';
import SiPayPanelInitialLoading from './initialLoading/initialLoading.index';
import { Header, Sidebar } from './components';
import Authentication from './authentication/authentication.index';
import Wallet from './wallet/wallet.index';
import { PATH } from 'data/30pay.path';
import Reports from './reports/reports.index';
import { Markets } from './markets/markets.index';
import { Trade } from './trade/trade.index';
import { BankAccounts } from './bankAccounts/bankAccounts.index';
import Profile from './profile/profile.index';
import Security from './security/security.index';
import Referral from './referral/referral.index';
import { Ticket } from './ticket/ticket.index';
import TicketById from './ticket/ticketById/ticketById.index';
import Dashboard from './dashboard/dashboard.index';
import { AuthenticateThankYouPage } from './components/thankYou/authenticate/authenticateThankYouPage.index';
import { WalletPaymentThankYouPage } from './components/thankYou/payment/page/wallet/walletPaymentThankYou.indexPage';
import { BuyPaymentThankYouPage } from './components/thankYou/payment/page/buy/buyPaymentThankYouPage.index';
import { NotFoundPage } from './components/404/404.index';
import PopupManager from './components/popupManager/popupManager.index';

const SiPayPanel: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const [isSidebarCollapse, setIsSidebarCollapse] = useState(false);

    useEffect(() => {
        siPayInitialize(props.dispatch);
    }, [props.dispatch]);

    return (
        <BrowserRouter>
            <ToastContainer
                position={'top-left'}
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Routes>
                <Route path={PATH.kycVerify} element={<AuthenticateThankYouPage />} />
                <Route path={PATH.paymentGatewayVerifyBuy} element={<BuyPaymentThankYouPage />} />
                <Route path={PATH.paymentGatewayVerifyWallet} element={<WalletPaymentThankYouPage />} />
                <Route path="*">
                    {props.isAuth === AuthStatus.inValid && <Route path="*" element={<Authentication />} />}

                    {props.isAuth === AuthStatus.valid && (
                        <Route
                            path="*"
                            element={
                                <PopupManager>
                                    <div className="flex w-full h-full">
                                        <Sidebar isCollapse={(e) => setIsSidebarCollapse(e)} />
                                        <div className="flex flex-col w-full h-full">
                                            <Header isSidebarCollapse={isSidebarCollapse} />
                                            <div
                                                className={`h-full min-h-[calc(100vh-70px)] flex-1 bg-background ${isSidebarCollapse ? 'md:mr-[96px] md:w-[calc(100%-96px)]' : 'md:mr-[248px] md:w-[calc(100%-248px)]'} mt-[70px] transition-all max-lg:pb-[64px]`}
                                            >
                                                <Routes>
                                                    <Route path={PATH.dashboard} element={<Dashboard />} />
                                                    <Route path={PATH.wallet} element={<Wallet />} />
                                                    <Route path={PATH.walletAction} element={<Wallet />} />
                                                    <Route path={PATH.reports} element={<Reports />} />
                                                    <Route path={PATH.markets} element={<Markets />} />
                                                    <Route path={PATH.trade} element={<Trade />} />
                                                    <Route path={PATH.cards} element={<BankAccounts />} />
                                                    <Route path={PATH.profile} element={<Profile />} />
                                                    <Route path={PATH.security} element={<Security />} />
                                                    <Route path={PATH.referral} element={<Referral />} />
                                                    <Route path={PATH.ticket} element={<Ticket />} />
                                                    <Route path={PATH.ticketById} element={<TicketById />} />

                                                    <Route path="*" element={<Navigate to={PATH.notFound} replace />} />
                                                </Routes>
                                            </div>
                                        </div>
                                    </div>
                                </PopupManager>
                            }
                        />
                    )}
                    {props.isAuth === AuthStatus.pending && <Route path="*" element={<SiPayPanelInitialLoading />} />}
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(SiPayPanel);
